// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AppGlobal.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action, computed } from 'mobx';
import { get } from 'lodash/fp';

class AppGlobal {
  @observable
  advancedSettings = {
    performance: {},
    security: {},
    other: {}
  };
  @observable systemDate = null;

  @computed
  get dataSourceLimitValue() {
    return this.advancedSettings.performance.dataSourceLimitValue;
  }

  constructor() {
    this.containerElement = null;
    this.countryCodes = [];
    this.currentUserContext = { token: null };
  }

  @action
  setPerformance(result: any): void {
    this.advancedSettings.performance = result;
  }

  @action
  setSecurity(result: any): void {
    this.advancedSettings.security = result;
  }

  @action
  setOther(result: any): void {
    this.advancedSettings.other = result;
  }
  
  setSystemDate(result: any): void {
    this.systemDate = result;
  }


  setCountryCodes(result: Array): void {
    this.countryCodes = result;
  }

  canShowPreview(): boolean {
    return get('advancedSettings.other.showPreviewValue', this);
  }

  /**
   * Get hide report header and footer setting
   * @returns { Boolean } A boolean value that indicates to hide report's header and footer.
   */
  doesHideReportHeaderAndFooter(): boolean {
    return get('advancedSettings.other.hideReportHeaderAndFooterValue', this);
  }
}

export default new AppGlobal();



// WEBPACK FOOTER //
// ./ui/Izenda.AppGlobal.js